const ApiBaseUrl = 'https://oz-config.thinkingbigbusiness.com.au'

export { ApiBaseUrl}